import {type ForestMassStatus, STATUS} from '@/domain/entities/ForestMassStatus';

class BusinessLogicBasedOnStatuses {
  constructor(readonly statuses: ForestMassStatus) {}
  isForestMassCut(): boolean {
    return (
      this.statuses.finsaStatus === STATUS.CUT_FORCED ||
      this.statuses.finsaStatus === STATUS.WEIGHT_PENDING ||
      this.statuses.finsaStatus === STATUS.CUT_WEIGHTED
    );
  }
}

export default BusinessLogicBasedOnStatuses;
